<template>
  <EvaluacionesTabContent :fetchStatus="fetchEvaluationStatus" :onRetry="fetchEvaluacionesDesempenio">
    <template #success>
      <v-container>
        <v-row justify="end">
          <v-col cols="auto">
            <v-btn icon title="Actualizar listado" @click="fetchEvaluacionesDesempenio()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-expansion-panels>
              <v-expansion-panel v-for="(grupoEvaluaciones, index) in conjuntosEvaluaciones" :key="index">
                <v-expansion-panel-header>
                  <div>
                    <v-icon class="mr-2 secondary--text">mdi-folder</v-icon>
                    {{ grupoEvaluaciones.header }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list color="transparent">
                    <v-list-item
                      v-for="(evaluacion, evaluacionKey) in grupoEvaluaciones.evaluaciones"
                      :key="evaluacionKey"
                    >
                      <v-list-item-content>
                        <v-list-item-title> {{ EVALUATION_TYPES[evaluacionKey] }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action class="d-inline">
                        <template v-if="!estatusEvaluacionOptions || estatusEvaluacionOptions.length === 0">
                          <v-progress-circular indeterminate color="secondary" size="24" />
                        </template>
                        <template v-else>
                          <EvaluacionStatusChip
                            :status="evaluacion.estatus"
                            :statusOptions="estatusEvaluacionOptions"
                            :editable="true && !isReadonly"
                            v-if="evaluacionKey === 'productividad'"
                            @update-status="onUpdateEstatusProductividad(evaluacion, $event)"
                          />
                          <EvaluacionStatusChip
                            :status="evaluacion.estatus"
                            :statusOptions="estatusEvaluacionOptions"
                            :editable="true && !isReadonly"
                            v-else-if="evaluacionKey === 'disciplinaAdministrativa'"
                            @update-status="onUpdateEstatusDisciplinaAdministrativa(evaluacion, $event)"
                          />
                          <EvaluacionStatusChip
                            :status="evaluacion.estatus"
                            :statusOptions="estatusEvaluacionOptions"
                            :editable="true && !isReadonly"
                            v-else-if="evaluacionKey === 'disciplinaOperativa'"
                            @update-status="onUpdateEstatusDisciplinaOperativa(evaluacion, $event)"
                          />
                          <EvaluacionStatusChip
                            :status="evaluacion.estatus"
                            :statusOptions="estatusEvaluacionOptions"
                            :editable="true && !isReadonly"
                            v-else-if="evaluacionKey === 'respetoPrincipios'"
                            @update-status="onUpdateEstatusRespetoPrincipios(evaluacion, $event)"
                          />
                          <EvaluacionStatusChip
                            :status="evaluacion.estatus"
                            :statusOptions="estatusEvaluacionOptions"
                            v-else
                          />
                        </template>
                        <v-btn icon @click="openEvaluacionDialog(evaluacion, evaluacionKey)">
                          <v-icon color="secondary">{{ isReadonly ? 'mdi-eye' : 'mdi-pencil' }}</v-icon>
                        </v-btn>
                        <v-btn icon @click="descargaEvaluacion(evaluacion, evaluacionKey)">
                          <v-icon color="secondary">mdi-download</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <v-btn small @click="exportExcel(grupoEvaluaciones.evaluaciones)" color="secondary">
                    Descargar cadena de resultados
                  </v-btn>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-container>
      <EvaluacionesDialogs
        v-if="activeDialog !== ''"
        :activeDialog="activeDialog"
        :evaluacion="selectedEvaluacion"
        :readonly="isReadonly"
        @close="activeDialog = ''"
      />
    </template>
  </EvaluacionesTabContent>
</template>

<script>
import EvaluacionProductividadCardComponent from '@src/components/expediente/evaluaciones/productividad/EvaluacionProductividadCardComponent.vue'
import EvaluacionStatusChip from '../chips/EvaluacionStatusChip.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '@src/plugins/dialog-types'
import { ACTION_STATUS, API_DATE_FORMAT } from '@src/const'
import LoadingState from '@src/components/common/LoadingState.vue'
import ErrorState from '@src/components/common/ErrorState.vue'
import CadenaResultados from '@modules/evaluacion-desempeño/domain/entities/CadenaResultados'
import EvaluacionesTabContent from '../../common/tabs/EvaluacionesTabContent.vue'
import GetConjuntoEvaluacionesUsecase from '@modules/evaluaciones/application/GetConjuntoEvaluaciones.usecase'
import EvaluacionesApiRepository from '@modules/evaluaciones/infrastructure/EvaluacionesApi.repository'
import DateAdapter from '@src/utils/DateAdapter'
import { EvaluacionProductividadAdapter } from '@src/modules/evaluacion-desempeño/application/adapters/EvaluacionProductividad.adapter'
import EvaluacionDisciplinaAdministrativaAdapter from '@src/modules/evaluacion-desempeño/application/adapters/EvaluacionDisciplinaAdministrativa.adapter'
import EvaluacionDisciplinaOperativaAdapter from '@src/modules/evaluacion-desempeño/application/adapters/EvaluacionDisciplinaOperativa.adapter'
import { RespetoPrincipiosAdapter } from '@src/modules/evaluacion-desempeño/application/adapters/RespetoPrincipios.adapter'
import EvaluacionesDialogs from '@src/components/desarrollo_policial/evaluacion-desempeño/dialogs/EvaluacionesDialogs.vue'
import GetEvaluacionDisciplinaOperativaUseCase from '@src/modules/evaluacion-desempeño/application/usecases/GetEvaluacionDisciplinaOperativa.usecase'
import EvaluacionDisciplinaOperativaApiRepository from '@src/modules/evaluacion-desempeño/infrastructure/EvaluacionDisciplinaOperativaApi.repository'
import { saveAs } from 'file-saver'
import axios from 'axios'
import { publicPath } from '../../../../../vue.config'
import GetEvaluacionDisciplinaAdministrativaByIdUseCase from '@src/modules/evaluacion-desempeño/application/usecases/GetEvaluacionDisciplinaAdministrativaById.usecase'
import EvaluacionDisciplinaAdministrativaApiRepository from '@src/modules/evaluacion-desempeño/infrastructure/EvaluacionDisciplinaAdministrativaApi.repository'
import getAntiguedadPersonal from '@src/utils/getAntiguedadPersonal'
import { PERFILES } from '@src/perfiles'
import { MENU_EXPEDIENTE_PERSONAL } from '@src/menuExpedientePersonal'

const ExcelJS = require('exceljs')
let buffer = null
let workbook = new ExcelJS.Workbook()
let worksheet = null
let cell = null

const EVALUATION_TYPES = {
  productividad: 'Productividad',
  disciplinaAdministrativa: 'Disciplina Administrativa',
  disciplinaOperativa: 'Disciplina Operativa',
  respetoPrincipios: 'Respeto a los Principios',
}

export default {
  components: {
    EvaluacionProductividadCardComponent,
    EvaluacionStatusChip,
    LoadingState,
    ErrorState,
    EvaluacionesTabContent,
    EvaluacionesDialogs,
  },

  props: {
    // FIXME: Redundant prop, should be removed when refactoring
    idPersonal: {
      type: [String, Number],
      required: true,
    },

    productividad: {
      type: Array,
      required: true,
    },

    disciplinaAdministrativa: {
      type: Array,
      required: true,
    },

    disciplinaOperativa: {
      type: Array,
      required: true,
    },

    respetoPrincipios: {
      type: Array,
      required: true,
    },
  },

  mounted() {
    this.$store.dispatch('estatusEvaluacion/fetchEstatusEvaluacion')
    this.fetchEvaluacionesDesempenio()
  },

  data() {
    return {
      EVALUATION_TYPES,
      ACTION_STATUS,
      fetchEvaluationStatus: ACTION_STATUS.IDLE,
      selectedProgramacionEvaluacion: null,
      conjuntosEvaluaciones: [],
      activeDialog: '',
      selectedEvaluacion: null,
      PERFILES,
      MENU_EXPEDIENTE_PERSONAL,
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    ...mapGetters('productividad', {
      productividadSingle: 'getProductividadSingle',
    }),
    ...mapGetters('respetoPrincipios', {
      respetoPrincipiosSingle: 'getRespetoPrincipiosSingle',
    }),
    ...mapGetters('estatusEvaluacion', {
      estatusEvaluacionOptions: 'getEstatusEvaluacion',
    }),
    ...mapGetters({ perfil: 'getPerfil' }),
    ...mapGetters('expediente', { selectedMenu: 'getSelectedMenu' }),

    isReadonly() {
      return this.perfil === PERFILES.Policia && this.selectedMenu === MENU_EXPEDIENTE_PERSONAL.CARRERA_POLICIAL
    },
  },

  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations('disciplinaAdministrativa', ['SET_SELECTED_DISCIPLINA_ADMINISTRATIVA']),
    ...mapActions('productividad', ['fetchProductividad', 'fetchProductividadById']),
    ...mapActions('respetoPrincipios', ['fetchRespetoPrincipios', 'fetchRespetoPrincipiosById']),
    ...mapActions('disciplinaOperativa', ['fetchDisciplinaOperativa']),
    ...mapActions('disciplinaAdministrativa', ['fetchDisciplinaAdministrativa']),

    async openEvaluacionDialog(evaluacion, evaluacionKey) {
      if (evaluacionKey === 'productividad') {
        await this.fetchProductividadById({
          fkidPersonal: this.idPersonal,
          idProductividad: evaluacion.id,
        })
        this.selectedEvaluacion = this.productividadSingle
        this.activeDialog = evaluacionKey
      } else if (evaluacionKey === 'respetoPrincipios') {
        await this.fetchRespetoPrincipiosById({
          fkidPersonal: this.idPersonal,
          idRespetoPrincipios: evaluacion.id,
        })
        this.selectedEvaluacion = this.respetoPrincipiosSingle
        this.activeDialog = evaluacionKey
      } else if (evaluacionKey === 'disciplinaOperativa') {
        this.selectedEvaluacion = await new GetEvaluacionDisciplinaOperativaUseCase(
          new EvaluacionDisciplinaOperativaApiRepository()
        ).execute({ idPersonal: this.idPersonal, idEvaluacion: evaluacion.id })
        this.activeDialog = evaluacionKey
      } else if (evaluacionKey === 'disciplinaAdministrativa') {
        this.SET_SELECTED_DISCIPLINA_ADMINISTRATIVA(evaluacion)
        this.SET_DIALOG({
          ...DIALOG_TYPES.EDITAR_EVALUACION_DISCIPLINA_ADMINISTRATIVA,
          props: {
            readonly: this.isReadonly,
          },
        })
      }
    },

    exportExcel(grupoEvaluaciones) {
      new CadenaResultados(grupoEvaluaciones, this.personal).generateXlsx()
    },

    async fetchEvaluacionesDesempenio() {
      try {
        this.fetchEvaluationStatus = ACTION_STATUS.LOADING
        const conjuntosEvaluaciones = await new GetConjuntoEvaluacionesUsecase(EvaluacionesApiRepository).execute(
          this.idPersonal
        )

        this.conjuntosEvaluaciones = conjuntosEvaluaciones.map((conjunto) => {
          const mainEvaluacion = conjunto.DisciplinaAdministrativa
          return {
            header: new DateAdapter(mainEvaluacion.fechaAplicacion, API_DATE_FORMAT).toHumanReadable(),
            evaluaciones: {
              productividad: EvaluacionProductividadAdapter.toEntity(conjunto.Productividad),
              disciplinaAdministrativa: EvaluacionDisciplinaAdministrativaAdapter.toDomain(mainEvaluacion),
              disciplinaOperativa: EvaluacionDisciplinaOperativaAdapter.toDomain(conjunto.DisciplinaOperativa),
              respetoPrincipios: RespetoPrincipiosAdapter.toEntity(conjunto.RespetoPrincipios),
            },
          }
        })
        this.fetchEvaluationStatus = ACTION_STATUS.SUCCEEDED
      } catch (error) {
        this.fetchEvaluationStatus = ACTION_STATUS.FAILED
        console.error('Error fetching evaluations:', error)
      }
    },

    async descargaEvaluacion(evaluacion, evaluacionKey) {
      if (evaluacionKey === 'productividad') {
        await this.fetchProductividadById({
          fkidPersonal: this.idPersonal,
          idProductividad: evaluacion.id,
        })
        this.handleDescargaEvaluacionProductividad(this.productividadSingle)
      } else if (evaluacionKey === 'disciplinaAdministrativa') {
        const disciplinaAdministrativa = await new GetEvaluacionDisciplinaAdministrativaByIdUseCase(
          new EvaluacionDisciplinaAdministrativaApiRepository()
        ).execute({ idPersonal: this.idPersonal, idEvaluacion: evaluacion.id })
        this.handleDescargaEvaluacionDisciplinaAdministrativa(disciplinaAdministrativa)
      } else if (evaluacionKey === 'disciplinaOperativa') {
        const disciplinaOperativa = await new GetEvaluacionDisciplinaOperativaUseCase(
          new EvaluacionDisciplinaOperativaApiRepository()
        ).execute({ idPersonal: this.idPersonal, idEvaluacion: evaluacion.id })
        this.handleDescargaEvaluacionDisciplinaOperativa(disciplinaOperativa)
      } else if (evaluacionKey === 'respetoPrincipios') {
        await this.fetchRespetoPrincipiosById({
          fkidPersonal: this.idPersonal,
          idRespetoPrincipios: evaluacion.id,
        })
        this.handleDescargaEvaluacionRespetoPrincipios(RespetoPrincipiosAdapter.toEntity(this.respetoPrincipiosSingle))
      }
    },

    async handleDescargaEvaluacionProductividad(evaluacion) {
      await axios(publicPath + 'evaluacion_productividad.xlsx', { responseType: 'arraybuffer' })
        .catch(function (err) {
          console.log('Error in getting data: ' + err)
        })
        .then(async function (res) {
          return res.data
        })
        .catch(function (err) {
          console.log('Error in parsin: ' + err)
        })
        .then(async (data) => {
          await workbook.xlsx.load(data)

          worksheet = workbook.getWorksheet(1)

          cell = worksheet.getCell('D7')
          cell.value = this.getFullName(evaluacion.Personal)
          cell = worksheet.getCell('D9')
          cell.value = evaluacion.Personal.CatPuestoDependencia
            ? evaluacion.Personal.CatPuestoDependencia.catPuesto.title
            : ''
          cell = worksheet.getCell('D11')
          cell.value = evaluacion.Personal.CatArea ? evaluacion.Personal.CatArea.nombre : ''
          cell = worksheet.getCell('D13')
          cell.value = evaluacion.Personal.CatPuestoDependencia
            ? evaluacion.Personal.CatPuestoDependencia.CatTipoPuesto.title
            : ''
          cell = worksheet.getCell('H7')
          cell.value = evaluacion.Personal.curp
          cell = worksheet.getCell('H9')
          cell.value = evaluacion.Personal.CUIP
          cell = worksheet.getCell('H11')
          cell.value = 'TLAXCALA'
          cell = worksheet.getCell('K11')
          cell.value = evaluacion.fechaAplicacion
          cell = worksheet.getCell('I13')
          cell.value = evaluacion.fechaInicial + ' - ' + evaluacion.fechaFin

          let index_reactivos = 18
          evaluacion.niveles.forEach((nivel) => {
            cell = worksheet.getCell('E' + index_reactivos)
            cell.value = nivel.realizados

            switch (nivel.fk_idCatFrecuencia) {
              case 1:
                cell = worksheet.getCell('F' + index_reactivos)
                cell.value = 'X'
                break
              case 2:
                cell = worksheet.getCell('G' + index_reactivos)
                cell.value = 'X'
                break
              case 3:
                cell = worksheet.getCell('H' + index_reactivos)
                cell.value = 'X'
                break
              case 4:
                cell = worksheet.getCell('I' + index_reactivos)
                cell.value = 'X'
                break
              case 5:
                cell = worksheet.getCell('J' + index_reactivos)
                cell.value = 'X'
                break
              case 6:
                cell = worksheet.getCell('K' + index_reactivos)
                cell.value = 'X'
                break
              default:
                break
            }
            index_reactivos += 1
          })

          let index_factores = 62

          evaluacion.factores.forEach((factor) => {
            cell = worksheet.getCell('G' + index_factores)
            cell.value = factor.cantidad
            cell = worksheet.getCell('H' + index_factores)
            cell.value = factor.descripcion
            index_factores += 1
          })

          cell = worksheet.getCell('G73')
          cell.value = this.getFullName(evaluacion.PersonalEvaluador)
          cell = worksheet.getCell('G74')
          cell.value = evaluacion.PersonalEvaluador.CatPuestoDependencia.catPuesto.title

          cell = worksheet.getCell('D74')
          cell.value = evaluacion.fechaAplicacion ?? ''

          worksheet.removeConditionalFormatting()
          buffer = await workbook.xlsx.writeBuffer()

          var blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          saveAs(blob, 'evaluacion_productividad.xlsx')
        })
    },

    async handleDescargaEvaluacionDisciplinaAdministrativa(evaluacion) {
      await axios(publicPath + 'evaluacion_disciplina_administrativa.xlsx', { responseType: 'arraybuffer' })
        .catch(function (err) {
          console.log('Error in getting data: ' + err)
        })
        .then(async function (res) {
          return res.data
        })
        .catch(function (err) {
          console.log('Error in parsin: ' + err)
        })
        .then(async (data) => {
          await workbook.xlsx.load(data)

          worksheet = workbook.getWorksheet(1)

          cell = worksheet.getCell('D7')
          cell.value = this.getFullName(evaluacion.evaluado)
          cell = worksheet.getCell('D9')
          cell.value = evaluacion.evaluado.CatPuestoDependencia.catDependencia.nombre
          cell = worksheet.getCell('D11')
          cell.value = evaluacion.instanciaInformadora
          cell = worksheet.getCell('J7')
          cell.value = evaluacion.fechaAplicacion
          cell = worksheet.getCell('J9')
          cell.value = evaluacion.evaluado.CatPuestoDependencia.catPuesto.puesto
          cell = worksheet.getCell('J11')
          cell.value = evaluacion.fechaInicio + ' - ' + evaluacion.fechaConclusion
          cell = worksheet.getCell('M7')
          cell.value = evaluacion.evaluado.unidadAnalisisTactico // Número de empleado
          cell = worksheet.getCell('M9')
          cell.value = getAntiguedadPersonal(evaluacion.evaluado.fechaIngresoEdoFza)
          cell = worksheet.getCell('M11')
          cell.value = evaluacion.periodicidad

          let index_incidencias = 16
          evaluacion.incidencias.forEach((incidencia) => {
            cell = worksheet.getCell('D' + index_incidencias)
            cell.value = incidencia.cantidad
            index_incidencias += 2
          })

          cell = worksheet.getCell('F15')
          cell.value = ''
          evaluacion.actasAdministrativas.forEach((acta, index) => {
            cell.value +=
              index +
              1 +
              '.' +
              'Descripción: ' +
              acta.descripcion +
              ' Fecha: ' +
              acta.fecha +
              ' Motivo: ' +
              acta.motivo +
              '\r\n'
          })

          cell = worksheet.getCell('H15')
          cell.value = ''
          evaluacion.estimulos.forEach((estimulo, index) => {
            cell.value +=
              index + 1 + '.' + 'Motivo: ' + estimulo.motivo + ' Descripción: ' + estimulo.descripcion + '\r\n'
          })

          cell = worksheet.getCell('K15')
          cell.value = ''
          evaluacion.reconocimientos.forEach((reconocimiento, index) => {
            cell.value +=
              index +
              1 +
              '.' +
              'Motivo: ' +
              reconocimiento.motivo +
              ' Descripción: ' +
              reconocimiento.descripcion +
              '\r\n'
          })

          cell = worksheet.getCell('H29')
          cell.value = this.getFullName(evaluacion.evaluador)
          cell = worksheet.getCell('H33')
          cell.value = evaluacion.evaluador.CatPuestoDependencia.catPuesto.puesto
          cell = worksheet.getCell('C32')
          cell.value = evaluacion.fechaAplicacion ?? ''

          worksheet.removeConditionalFormatting()
          buffer = await workbook.xlsx.writeBuffer()

          const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          saveAs(blob, 'evaluacion_disciplina_administrativa.xlsx')
        })
    },

    async handleDescargaEvaluacionDisciplinaOperativa(evaluacion) {
      await axios(publicPath + 'evaluacion_disciplina_operativa.xlsx', { responseType: 'arraybuffer' })
        .catch(function (err) {
          console.log('Error in getting data: ' + err)
        })
        .then(async function (res) {
          return res.data
        })
        .catch(function (err) {
          console.log('Error in parsin: ' + err)
        })
        .then(async (data) => {
          console.log(evaluacion)
          await workbook.xlsx.load(data)

          worksheet = workbook.getWorksheet(1)

          cell = worksheet.getCell('C7')
          cell.value = this.getFullName(evaluacion.evaluado)
          cell = worksheet.getCell('C9')
          cell.value = evaluacion.evaluado.CatPuestoDependencia.catDependencia.nombre
          cell = worksheet.getCell('C11')
          cell.value = evaluacion.instanciaInformadora
          cell = worksheet.getCell('J7')
          cell.value = evaluacion.fechaAplicacion
          cell = worksheet.getCell('J9')
          cell.value = evaluacion.evaluado.CatPuestoDependencia.catPuesto.title
          cell = worksheet.getCell('J11')
          cell.value = evaluacion.fechaInicio + ' - ' + evaluacion.fechaConclusion
          cell = worksheet.getCell('M7')
          cell.value = evaluacion.evaluado.unidadAnalisisTactico // Número de empleado
          cell = worksheet.getCell('M9')
          cell.value = getAntiguedadPersonal(evaluacion.evaluado.fechaIngresoEdoFza)
          cell = worksheet.getCell('M11')
          cell.value = evaluacion.periodicidad

          const amountQuejas = evaluacion.procedimientos.filter(({ idProcedimiento }) => idProcedimiento == 1).length
          cell = worksheet.getCell('B18')
          cell.value = String(amountQuejas)

          const amountAdministrativos = evaluacion.procedimientos.filter(
            ({ idProcedimiento }) => idProcedimiento == 2
          ).length
          cell = worksheet.getCell('B20')
          cell.value = String(amountAdministrativos)

          const amountAveriguaciones = evaluacion.procedimientos.filter(
            ({ idProcedimiento }) => idProcedimiento == 3
          ).length
          cell = worksheet.getCell('B22')
          cell.value = String(amountAveriguaciones)

          const amountCarpetasInvestigacion = evaluacion.procedimientos.filter(
            ({ idProcedimiento }) => idProcedimiento == 4
          ).length
          cell = worksheet.getCell('B24')
          cell.value = String(amountCarpetasInvestigacion)

          cell = worksheet.getCell('F15')
          cell.value = ''
          evaluacion.procedimientos.forEach((procedimiento, index) => {
            cell.value += index + 1 + '.' + procedimiento.numero + '\r\n'
          })

          cell = worksheet.getCell('G15')
          cell.value = ''
          evaluacion.procedimientos.forEach((procedimiento, index) => {
            cell.value += index + 1 + '.' + procedimiento.fecha + '\r\n'
          })

          cell = worksheet.getCell('H15')
          cell.value = ''
          evaluacion.procedimientos.forEach((procedimiento, index) => {
            cell.value += index + 1 + '.' + procedimiento.motivo + '\r\n'
          })

          cell = worksheet.getCell('J15')
          cell.value = ''
          evaluacion.procedimientos.forEach((procedimiento, index) => {
            cell.value += index + 1 + '.' + procedimiento.estatusProcedimiento + '\r\n'
          })

          cell = worksheet.getCell('K15')
          cell.value = ''
          evaluacion.procedimientos.forEach((procedimiento, index) => {
            cell.value += index + 1 + '.' + procedimiento.descripcion + '\r\n'
          })

          cell = worksheet.getCell('N15')
          cell.value = ''
          evaluacion.procedimientos.forEach((procedimiento, index) => {
            cell.value += index + 1 + '.' + procedimiento.resolucion + '\r\n'
          })

          cell = worksheet.getCell('H40')
          cell.value = this.getFullName(evaluacion.evaluador)
          cell = worksheet.getCell('H41')
          cell.value = evaluacion.evaluador.CatPuestoDependencia.catPuesto.title

          cell = worksheet.getCell('B40')
          cell.value = evaluacion.fechaAplicacion ?? ''

          worksheet.removeConditionalFormatting()
          buffer = await workbook.xlsx.writeBuffer()

          const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          saveAs(blob, 'evaluacion_disciplina_operativa.xlsx')
        })
    },

    async handleDescargaEvaluacionRespetoPrincipios(evaluacion) {
      await axios(publicPath + 'evaluacion_respeto_principios.xlsx', { responseType: 'arraybuffer' })
        .catch(function (err) {
          console.log('Error in getting data: ' + err)
        })
        .then(async function (res) {
          return res.data
        })
        .catch(function (err) {
          console.log('Error in parsin: ' + err)
        })
        .then(async (data) => {
          await workbook.xlsx.load(data)

          worksheet = workbook.getWorksheet(1)

          cell = worksheet.getCell('E7')
          cell.value = this.getFullName(evaluacion.evaluado)
          cell = worksheet.getCell('E9')
          cell.value = evaluacion.evaluado.CatPuestoDependencia
            ? evaluacion.evaluado.CatPuestoDependencia.catPuesto.title
            : ''
          cell = worksheet.getCell('E11')
          cell.value = evaluacion.evaluado.CatPuestoDependencia
            ? evaluacion.evaluado.CatPuestoDependencia.CatTipoPuesto.title
            : ''
          cell = worksheet.getCell('M9')
          cell.value = evaluacion.evaluado.CatPuestoDependencia
            ? evaluacion.evaluado.CatPuestoDependencia.catDependencia.nombre
            : ''
          cell = worksheet.getCell('M11')
          cell.value = evaluacion.evaluado.CatArea ? evaluacion.evaluado.CatArea.nombre : ''
          cell = worksheet.getCell('E13')
          cell.value = evaluacion.periodicidad
          cell = worksheet.getCell('M7')
          cell.value = evaluacion.evaluado.curp
          cell = worksheet.getCell('R7')
          cell.value = evaluacion.evaluado.CUIP
          cell = worksheet.getCell('R11')
          cell.value = 'TLAXCALA'
          cell = worksheet.getCell('S13')
          cell.value = evaluacion.fechaAplicacion
          cell = worksheet.getCell('J13')
          cell.value = evaluacion.fechaInicio + ' - ' + evaluacion.fechaConclusion

          let index_reactivos = 21
          evaluacion.reactivos.forEach((frecuencia) => {
            switch (frecuencia.idFrecuencia) {
              case 1:
                cell = worksheet.getCell('N' + index_reactivos)
                cell.value = 'X'
                break
              case 2:
                cell = worksheet.getCell('Q' + index_reactivos)
                cell.value = 'X'
                break
              case 3:
                cell = worksheet.getCell('R' + index_reactivos)
                cell.value = 'X'
                break
              case 4:
                cell = worksheet.getCell('S' + index_reactivos)
                cell.value = 'X'
                break
              case 5:
                cell = worksheet.getCell('T' + index_reactivos)
                cell.value = 'X'
                break
              default:
                break
            }
            index_reactivos += 1
          })

          cell = worksheet.getCell('E47')
          cell.value = evaluacion.observaciones
          cell = worksheet.getCell('E51')
          cell.value = this.getFullName(evaluacion.evaluador)
          cell = worksheet.getCell('E52')
          cell.value = evaluacion.evaluador.CatPuestoDependencia.catPuesto.title

          worksheet.removeConditionalFormatting()
          buffer = await workbook.xlsx.writeBuffer()

          const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          saveAs(blob, 'evaluacion_respeto_principios.xlsx')
        })
    },
    async onUpdateEstatusProductividad(evaluacion, nuevoEstatus) {
      evaluacion.estatus = nuevoEstatus.title
      await this.$store.dispatch('productividad/updateEstatusProductividad', {
        fk_idPersonal: this.idPersonal,
        id: evaluacion.id,
        fk_idCatEstatusEvaluacion: nuevoEstatus.id,
      })
      this.fetchEvaluacionesDesempenio()
    },
    async onUpdateEstatusDisciplinaAdministrativa(evaluacion, nuevoEstatus) {
      evaluacion.estatus = nuevoEstatus.title
      await this.$store.dispatch('disciplinaAdministrativa/updateEstatus', {
        fk_idPersonal: this.idPersonal,
        id: evaluacion.id,
        fk_idCatEstatusEvaluacion: nuevoEstatus.id,
      })
      this.fetchEvaluacionesDesempenio()
    },
    async onUpdateEstatusDisciplinaOperativa(evaluacion, nuevoEstatus) {
      evaluacion.estatus = nuevoEstatus.title
      await this.$store.dispatch('disciplinaOperativa/updateEstatus', {
        fk_idPersonal: this.idPersonal,
        id: evaluacion.id,
        fk_idCatEstatusEvaluacion: nuevoEstatus.id,
      })
      this.fetchEvaluacionesDesempenio()
    },
    async onUpdateEstatusRespetoPrincipios(evaluacion, nuevoEstatus) {
      evaluacion.estatus = nuevoEstatus.title
      await this.$store.dispatch('respetoPrincipios/updateEstatusRespetoPrincipios', {
        fk_idPersonal: this.idPersonal,
        id: evaluacion.id,
        fk_idCatEstatusEvaluacion: nuevoEstatus.id,
      })
      this.fetchEvaluacionesDesempenio()
    },
  },
}
</script>
